/** i18n.ts */

import Vue from "vue";
import VueI18n from "vue-i18n";
import pt from "./locales/pt.json";
import en from "./locales/en.json";

Vue.use(VueI18n);

/** Default language */
const defaultLanguage = "pt";

/** Get from the storage the selected language */
const language = localStorage.getItem("lang") ?? defaultLanguage;

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: defaultLanguage,
  messages: { pt, en },
});
